// ChargerTable.jsx - 充电桩遥测数据表
import React from 'react';
import { Table, Tag } from 'antd';
import { useTranslation } from '../../../../utils/useI18n';

const COLORS = { primary: '#00d4ff', muted: 'rgba(255,255,255,0.6)' };
const fmt0 = v => (v != null && !isNaN(v) ? (typeof v === 'number' ? v.toFixed(2) : v) : '-');
const fmtTime = t => t ? new Date(t).toLocaleString() : '-';

export default function ChargerTable({ data }) {
  const { t } = useTranslation();

  const columns = [
    { title: 'SN', dataIndex: 'sn', key: 'sn', width: 100, render: v => <span style={{ color: COLORS.primary }}>{v || '-'}</span> },
    { title: t('cloud.globalNo'), dataIndex: 'global_no', key: 'global_no', width: 120, render: v => <span style={{ color: COLORS.primary }}>{v || '-'}</span> },
    { title: t('cloud.devNo'), dataIndex: 'dev_no', key: 'dev_no', width: 120, render: v => v || '-' },
    { title: t('cloud.deviceType'), dataIndex: 'device_type', key: 'device_type', width: 100, render: v => v || '-' },
    { title: t('cloud.online'), dataIndex: 'online', key: 'online', width: 70, render: v => <Tag color={v === 1 ? 'green' : 'default'}>{v === 1 ? t('status.online') : t('status.offline')}</Tag> },
    { title: t('cloud.state'), dataIndex: 'state', key: 'state', width: 90, render: v => v || '-' },
    { title: t('cloud.intervalStart'), dataIndex: 'interval_start', key: 'interval_start', width: 160, render: fmtTime },
    { title: t('cloud.intervalEnd'), dataIndex: 'interval_end', key: 'interval_end', width: 160, render: fmtTime },
    { title: t('cloud.dataQuality'), dataIndex: 'data_quality', key: 'data_quality', width: 90, render: v => v || '-' },
    { title: t('cloud.mappingSource'), dataIndex: 'mapping_source', key: 'mapping_source', width: 100, render: v => v || '-' },
    { title: t('cloud.activePowerKw2'), dataIndex: 'active_power_kw', key: 'active_power_kw', width: 110, render: v => fmt0(v) },
    { title: t('cloud.recordedAt'), dataIndex: 'recorded_at', key: 'recorded_at', width: 160, render: fmtTime },
  ];

  if (!data || data.length === 0) return null;

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ color: COLORS.muted, fontSize: 12, marginBottom: 8 }}>{t('cloud.telemetryCharger')}</div>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        pagination={{ pageSize: 5, showSizeChanger: false }}
        scroll={{ x: 2000 }}
        style={{ background: 'transparent' }}
      />
    </div>
  );
}
